var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useGiveawaySection } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawaySection';
import { GiveawayTimer } from 'root/src/client/web/giveaway/features/GiveawaySection/GiveawayTimer';
import { GiveawayStatus } from '@daredrop-com/rewards-api-contract';
import { Cup, CupSize, CupVariant } from 'root/src/client/web/giveaway/components/Cup';
import { EnterGiveawayButton } from 'root/src/client/web/giveaway/features/GiveawaySection/EnterGiveawayButton';
import { ButtonNew, ButtonNewVariant } from 'root/src/client/v2/common/components/form/ButtonNew';
import { useAuthModals } from 'root/src/client/web/auth/hooks/useAuthModals';
import { BaseTooltip, BaseTooltipContent } from 'root/src/client/v2/common/components/BaseTooltip/BaseTooltip';
import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
import { useGiveawayTermsCheckbox, } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawayTermsCheckbox';
import { useBetween } from 'use-between';
import { useEffect, useState, memo } from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import { FaSteam } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
import 'react-phone-number-input/style.css';
import { defaultCountries, FlagImage, parseCountry, usePhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { InputAdornment, MenuItem, Select, TextField, Typography } from '@mui/material';
import { OTPInput } from 'input-otp';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useMutation } from '@tanstack/react-query';
import { authApi } from 'root/src/shared/util/authApi';
import toast from 'react-hot-toast';
import { getErrorMessage } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { useGiveawayAutoEnter } from 'root/src/client/v2/giveaways/features/GiveawayAutoEnter/hooks/useGiveawayAutoEnter';
import { useDocumentOverflow } from 'root/src/client/v2/common/contexts/modal.context';
import { TourProvider } from '@reactour/tour';
import Image from 'next/image';
import Sits from 'root/src/client/public/sits_01.png';
const OTP_LENGTH = 6;
const RESEND_COOLDOWN_SECONDS = 30;
export const GiveawayTermsCheckbox = memo(() => {
    const { isGiveawayTermsVisible, displayGiveawayTermsModal, isGiveawayTermsLoading, } = useGiveawaySection();
    const { isGiveawayTermsCheckboxSelected, toggleGiveawayTermsCheckbox, } = useBetween(useGiveawayTermsCheckbox);
    if (!isGiveawayTermsVisible) {
        return null;
    }
    return (<div className="flex flex-initial w-full gap-2 text-center justify-center items-center">
			{isGiveawayTermsLoading ? <LoadingCircles width={30} height={30}/> : (<FormControlLabel name="giveawayTermsCheckbox" control={(<Checkbox id="giveawayTermsCheckbox" checked={isGiveawayTermsCheckboxSelected} onChange={() => toggleGiveawayTermsCheckbox()}/>)} label={(<div className="ml-2 select-none text-xs sm:text-base">
							<label htmlFor="giveawayTermsCheckbox">I agree to the</label>
							{' '}
							<button onClick={displayGiveawayTermsModal} type="button" className="underline text-link">
								Terms and Conditions
							</button>
						</div>)}/>)}
		</div>);
});
export const ViewerGiveawaySection = memo(() => {
    const { classes } = useGiveawaySection();
    return (<OnboardingProvider>
			<AutoEnterTrigger />
			<div className={classes.root} data-giveaway-onboarding="enter">
				<span className={classes.header}>Reward giveaway</span>
				<GiveawaySection />
			</div>
		</OnboardingProvider>);
});
const OnboardingProvider = memo(({ children }) => {
    const overflow = useDocumentOverflow();
    return (<TourProvider showCloseButton={false} showNavigation={false} showPrevNextButtons={false} afterOpen={() => {
            overflow.hide();
        }} beforeClose={() => {
            overflow.show();
        }} styles={{
            badge: () => ({
                display: 'none',
            }),
            maskRect: props => (Object.assign(Object.assign({}, props), { fill: 'none', background: 'transparent' })),
            maskArea: props => (Object.assign(Object.assign({}, props), { fill: '#060606' })),
            maskWrapper: props => (Object.assign(Object.assign({}, props), { fill: 'transparent' })),
            highlightedArea: props => (Object.assign(Object.assign({}, props), { fill: 'transparent' })),
            clickArea: props => (Object.assign(Object.assign({}, props), { fill: '#060606' })),
            popover: props => (Object.assign(Object.assign({}, props), { borderRadius: 12 })),
        }} steps={[]}>
			{children}
		</TourProvider>);
});
const AutoEnterTrigger = memo(() => {
    useGiveawayAutoEnter();
    return null;
});
var VerificationType;
(function (VerificationType) {
    VerificationType["SMS"] = "sms";
    VerificationType["Steam"] = "steam";
})(VerificationType || (VerificationType = {}));
var SMSVerificationStep;
(function (SMSVerificationStep) {
    SMSVerificationStep["EnterPhone"] = "enter-phone";
    SMSVerificationStep["EnterCode"] = "enter-code";
})(SMSVerificationStep || (SMSVerificationStep = {}));
const verificationTypes = [
    { label: 'Steam', value: VerificationType.Steam, icon: FaSteam },
];
const VerifyPhoneNumber = memo(({ onSuccess, isDisabled, disabledMessage, }) => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [otpCode, setOtpCode] = useState('');
    const [step, setStep] = useState(SMSVerificationStep.EnterPhone);
    const [resendCooldown, setResendCooldown] = useState(0);
    const sendSMSCode = useSendSMSCodeMutation();
    const verifySMSCode = useVerifySMSCodeMutation();
    const verifyPhoneNumberMutation = useMutation({
        mutationFn: () => __awaiter(void 0, void 0, void 0, function* () {
            yield verifySMSCode.mutateAsync(otpCode);
            yield onSuccess();
        }),
        mutationKey: ['verify-phone-number-submit'],
    });
    const phoneUtil = PhoneNumberUtil.getInstance();
    const isPhoneNumberValid = (() => {
        if (!phoneNumber)
            return false;
        try {
            const parsed = phoneUtil.parse(phoneNumber);
            return phoneUtil.isValidNumber(parsed);
        }
        catch (_a) {
            return false;
        }
    })();
    useEffect(() => {
        if (resendCooldown <= 0)
            return;
        const timer = setInterval(() => {
            setResendCooldown(prev => prev - 1);
        }, 1000);
        // eslint-disable-next-line consistent-return
        return () => {
            clearInterval(timer);
        };
    }, [resendCooldown]);
    const startResendCooldown = () => {
        setResendCooldown(RESEND_COOLDOWN_SECONDS);
    };
    const onSendCodeClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isDisabled) {
            toast.error(disabledMessage || 'This action is currently disabled.');
            return;
        }
        if (!isPhoneNumberValid) {
            toast.error('Please enter a valid phone number.');
            return;
        }
        try {
            yield sendSMSCode.mutateAsync(phoneNumber);
            toast.success('Verification code sent!');
            setStep(SMSVerificationStep.EnterCode);
            startResendCooldown();
        }
        catch (error) {
            console.error(error);
            const message = getErrorMessage(error);
            toast.error(message);
        }
    });
    const onChangeNumberClick = () => {
        setStep(SMSVerificationStep.EnterPhone);
        setOtpCode('');
        setResendCooldown(0);
    };
    const onResendCodeClick = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield sendSMSCode.mutateAsync(phoneNumber);
            toast.success('Code resent!');
            startResendCooldown();
        }
        catch (error) {
            console.error(error);
            const message = getErrorMessage(error);
            toast.error(message);
        }
    });
    const onVerifyClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isDisabled) {
            toast.error(disabledMessage || 'This action is currently disabled.');
            return;
        }
        try {
            yield verifyPhoneNumberMutation.mutateAsync();
        }
        catch (error) {
            const message = getErrorMessage(error);
            toast.error(message);
        }
    });
    const isSendingCode = sendSMSCode.isPending;
    const isVerifying = verifyPhoneNumberMutation.isPending;
    const isResendDisabled = isSendingCode || resendCooldown > 0;
    const isVerifyDisabled = isVerifying || otpCode.length < OTP_LENGTH;
    const isSendCodeDisabled = isSendingCode || !isPhoneNumberValid;
    switch (step) {
        case SMSVerificationStep.EnterPhone:
            return (<div className="flex flex-initial flex-col gap-4">
				<MuiPhone value={phoneNumber} onChange={(d) => {
                    setPhoneNumber(d || '');
                }}/>
				<BaseTooltip tooltip={Boolean(disabledMessage) && (<BaseTooltipContent>
							{disabledMessage}
						</BaseTooltipContent>)}>
					<ButtonNew className="w-full" onClick={onSendCodeClick} disabled={isSendCodeDisabled}>
						{isSendingCode ? 'Sending...' : 'Send code'}
					</ButtonNew>

				</BaseTooltip>
			</div>);
        case SMSVerificationStep.EnterCode:
            return (<div className="flex flex-col gap-4">
				<div className="flex flex-col gap-2">
					<span className="text-sm text-center text-gray-400">
						Enter the code sent to {isPhoneNumberValid ? phoneUtil.format(phoneUtil.parse(phoneNumber), 1) : phoneNumber}
					</span>
					<OTPInput maxLength={6} value={otpCode} onChange={setOtpCode} containerClassName="flex gap-2 justify-center" render={({ slots }) => (<div className="flex gap-2 justify-center pointer-events-none">
								{slots.map((slot, idx) => {
                        var _a;
                        return (<div 
                        /* eslint-disable-next-line react/no-array-index-key */
                        key={idx.toString()} className={twMerge('w-10 h-12 flex items-center justify-center border-2 rounded-md text-xl font-mono', slot.isActive ? 'border-teal' : 'border-[rgba(255,255,255,.1)]', 'bg-[rgba(0,0,0,.1)]')}>
										{(_a = slot.char) !== null && _a !== void 0 ? _a : (slot.hasFakeCaret && (<div className="w-px h-6 bg-teal animate-pulse"/>))}
									</div>);
                    })}
							</div>)}/>
				</div>
				<div className="flex flex-col gap-4">
					<div>
						<ButtonNew type="button" className="w-full flex items-center justify-center gap-2" onClick={onVerifyClick} disabled={isVerifyDisabled}>
							{isVerifying ? 'Verifying...' : 'Verify'}
						</ButtonNew>
					</div>
					<div className="flex justify-center gap-3 items-center">
						<button onClick={onResendCodeClick} type="button" className="text-[rgba(255,255,255,.5)] text-sm font-medium disabled:opacity-50" disabled={isResendDisabled}>
							{isSendingCode ? 'Sending...' : resendCooldown > 0 ? `Resend code (${resendCooldown}s)` : 'Resend code'}
						</button>
						<button onClick={onChangeNumberClick} type="button" className="text-[rgba(255,255,255,.5)] text-sm font-medium">
							Change number
						</button>
					</div>
				</div>
			</div>);
        default:
            return null;
    }
});
const useSendSMSCodeMutation = () => {
    return useMutation({
        mutationFn: (phoneNumber) => __awaiter(void 0, void 0, void 0, function* () {
            return authApi.sendSMSVerification(phoneNumber);
        }),
        mutationKey: ['send-sms-code'],
    });
};
const useVerifySMSCodeMutation = () => {
    return useMutation({
        mutationFn: (code) => __awaiter(void 0, void 0, void 0, function* () {
            return authApi.verifySMSCode(code);
        }),
        mutationKey: ['verify-sms-code'],
    });
};
export const VerificationSection = memo(({ onSuccess }) => {
    const [tab, setTab] = useState(VerificationType.Steam);
    const { isGiveawayTermsVisible, giveaway } = useGiveawaySection();
    const { isGiveawayTermsCheckboxSelected } = useBetween(useGiveawayTermsCheckbox);
    if (!giveaway) {
        return null;
    }
    return (<div className="flex flex-initial flex-col gap-4 w-full justify-center items-center">
			<p className="text-sm uppercase font-extrabold text-placeholder flex gap-2 items-center justify-center">
				Select verification method
			</p>
			<Tabs.Root value={tab} onValueChange={value => setTab(value)} className="flex flex-col gap-4 w-full 2xl:w-2/3">
				<Tabs.TabsList className="flex w-full flex-initial relative bg-[rgba(100,100,100,.1)] rounded-2xl p-1.5">
					{verificationTypes.map((type) => {
            const isActive = tab === type.value;
            return (<Tabs.Trigger key={type.value} className={twMerge('flex flex-col justify-center py-2 relative items-center gap-2 motion-safe:duration-125', !isActive && 'opacity-50')} value={type.value}>
								{isActive && (<motion.div layoutId="underline" className="absolute left-0 top-0 w-full h-full bg-white/20 rounded-xl" transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }} style={{ borderRadius: 12,
                        willChange: 'transform',
                        WebkitBackfaceVisibility: 'hidden',
                        transform: 'translateZ(0)',
                    }}/>)}
								<div className={twMerge('z-10 flex justify-center items-center gap-2 font-bold uppercase', isActive && 'text-white')}>
									<type.icon className={twMerge('', isActive && 'fill-white')}/> {type.label}
								</div>
							</Tabs.Trigger>);
        })}
				</Tabs.TabsList>
				<Tabs.Content value={VerificationType.SMS}>
					<VerifyPhoneNumber onSuccess={onSuccess} isDisabled={isGiveawayTermsVisible && !isGiveawayTermsCheckboxSelected} disabledMessage="Please agree to the Terms and Conditions to proceed."/>
				</Tabs.Content>
				<Tabs.Content value={VerificationType.Steam}>
					<SignInWithSteam />
				</Tabs.Content>
			</Tabs.Root>
		</div>);
});
const getDefaultCountry = () => {
    var _a;
    const locale = (navigator === null || navigator === void 0 ? void 0 : navigator.language) || 'en-US';
    const country = (_a = locale.split('-')[1]) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    const isValidCountry = country && defaultCountries.some((c) => {
        const { iso2 } = parseCountry(c);
        return iso2 === country;
    });
    if (isValidCountry) {
        return country;
    }
    return 'us';
};
export const MuiPhone = (_a) => {
    var { value, onChange } = _a, restProps = __rest(_a, ["value", "onChange"]);
    const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } = usePhoneInput({
        defaultCountry: getDefaultCountry(),
        value,
        countries: defaultCountries,
        onChange: (data) => {
            onChange(data.phone);
        },
    });
    return (<TextField variant="outlined" label="Phone number" color="primary" placeholder="Phone number" name="phone" autoComplete="tel" value={inputValue} onChange={handlePhoneValueChange} type="tel" inputRef={inputRef} InputProps={{
            startAdornment: (<InputAdornment position="start" style={{ marginRight: '2px', marginLeft: '-8px' }}>
						<Select MenuProps={{
                    style: {
                        height: 'auto',
                        width: '360px',
                        top: '10px',
                        left: '-34px',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    },
                }} sx={{
                    width: 'max-content',
                    // Remove default outline (display only on focus)
                    fieldset: {
                        display: 'none',
                    },
                    '&.Mui-focused:has(div[aria-expanded="false"])': {
                        fieldset: {
                            display: 'block',
                        },
                    },
                    // Update default spacing
                    '.MuiSelect-select': {
                        padding: '8px',
                        paddingRight: '24px !important',
                    },
                    svg: {
                        right: 0,
                    },
                }} value={country.iso2} onChange={e => setCountry(e.target.value)} renderValue={iso2 => (<FlagImage iso2={iso2} style={{ display: 'flex' }}/>)}>
							{defaultCountries.map((c) => {
                    const parsedCountry = parseCountry(c);
                    return (<MenuItem key={parsedCountry.iso2} value={parsedCountry.iso2}>
										<FlagImage iso2={parsedCountry.iso2} style={{ marginRight: '8px' }}/>
										<Typography marginRight="8px">{parsedCountry.name}</Typography>
										<Typography color="gray">+{parsedCountry.dialCode}</Typography>
									</MenuItem>);
                })}
						</Select>
					</InputAdornment>),
        }} {...restProps}/>);
};
export const SignInWithSteam = memo(() => {
    const { giveaway, isAuthenticated, signIntoSteam, isSteamLoading, isGiveawayTermsVisible, } = useGiveawaySection();
    const { displaySignInModal } = useAuthModals();
    if (!giveaway) {
        return null;
    }
    if (!isAuthenticated) {
        return <ButtonNew className="font-bold" onClick={() => displaySignInModal()}>Sign In</ButtonNew>;
    }
    return (<div className="relative w-full flex flex-col gap-2">
			{!giveaway.isSteamEntered && (<div className="hidden sm:block absolute -top-2.5 -right-2 z-10">
					<BaseTooltip tooltip={(<BaseTooltipContent className="bg-teal text-black font-semibold">
								Sign in with Steam to earn +2 extra entries!
							</BaseTooltipContent>)}>
						<span className="text-[10px] font-black uppercase tracking-widest bg-teal text-black rounded-full px-2.5 py-1 cursor-help animate-bounce">
							Bonus
						</span>
					</BaseTooltip>
				</div>)}
			<BaseTooltip triggerClassName="w-full" tooltip={isGiveawayTermsVisible ? <BaseTooltipContent className="bg-black text-white">Please agree to the Terms and Conditions to proceed.</BaseTooltipContent> : <BaseTooltipContent className="bg-black text-white">Click to sign in with Steam and earn +2 extra entries!</BaseTooltipContent>}>
				<ButtonNew variant={ButtonNewVariant.Headless} disabled={isSteamLoading} onClick={e => signIntoSteam(e)} type="button">
					<Image src={Sits.src} width={Sits.width} height={Sits.height} alt="Sign in with Steam"/>
				</ButtonNew>
			</BaseTooltip>
			{!giveaway.isSteamEntered && (<div className="sm:hidden flex flex-col items-center text-center py-2 px-4 mt-1">
					<p className="text-[10px] font-black uppercase tracking-widest text-teal">Bonus</p>
					<p className="text-xs text-teal">
						Sign in with Steam to earn +2 extra entries!
					</p>
				</div>)}
		</div>);
});
const ViewerGiveawayInactive = memo(() => {
    const { classes } = useGiveawaySection();
    return (<>
			<Cup variant={CupVariant.Silver}/>
			<span className={classes.creatorNoActiveGiveaway}>This creator currently has no active<br /> giveaways</span>
			<SignInWithSteam />
		</>);
});
const ViewerGiveawayActiveEnter = () => {
    const { isActive, isEntered, isPickingWinner } = useGiveawaySection();
    return (<>
			{isActive && <GiveawayTimer />}
			{(!isEntered && !isPickingWinner) && <EnterGiveawayButton />}
		</>);
};
const ViewerGiveawayActive = memo(() => {
    const { classes, isActive } = useGiveawaySection();
    return (<>
			{isActive && <GiveawayTimer />}
			<Cup size={CupSize.MEDIUM} variant={CupVariant.Gold}/>
			<span className={classes.creatorNoActiveGiveaway}>
				Reward giveaway in progress
			</span>
		</>);
});
const GiveawaySchedulerActive = memo(() => {
    return (<div className="flex flex-col items-center justify-center gap-2">
			<span className="font-bold font-mono uppercase text-xl text-center">Giveaway is being prepared</span>
			<LoadingCircles width={60} height={60}/>
		</div>);
});
const GiveawaySection = memo(() => {
    const { giveaway, isEntered, giveawayScheduler } = useGiveawaySection();
    if (!giveaway) {
        if ((giveawayScheduler === null || giveawayScheduler === void 0 ? void 0 : giveawayScheduler.status) === GiveawayStatus.Active) {
            return <GiveawaySchedulerActive />;
        }
        return <ViewerGiveawayInactive />;
    }
    if (giveaway.status === GiveawayStatus.Active) {
        if (isEntered) {
            return <ViewerGiveawayActive />;
        }
        return <ViewerGiveawayActiveEnter />;
    }
    return null;
});
